const desactivado = [
  {
    action: 'access',
    subject: 'accessDenied'
  },

  {
    action: 'access',
    subject: 'billingChild1'
  },

  {
    action: 'access',
    subject: 'billingChild2'
  },

  {
    action: 'access',
    subject: 'billingChild3'
  },

  {
    action: 'access',
    subject: 'notFound'
  },

  {
    action: 'access',
    subject: 'updatingLicence'
  },

  {
    action: 'access',
    subject: 'landingUpgradePlan'
  }
]

export default desactivado
